export const modifiedReasonConfig = [
    'publicCommissionTypes',
    'roles',
    'users',
    'accountingExternalTransactions',
    'accountingGatewayAccounts',
    'accountingGatewayTransactions',
    'accountingSystemAccounts',
    'accountingSystemTransactions',
    'accountingWithdrawalTransactions',
    'accountingAgentTransactions',
    'publicGatewayApis',
    'publicGatewaySettings',
    'publicGateways',
    'publicTerminalShopWindows',
    'publicMerchantTerminalGateways',
    'publicMerchantTerminals',
    'publicMerchants',
    'publicAppeals',
    'publicChargebacks',
    'publicFrauds',
    'publicCommissions',
    'cryptoCoins'
];
